import { HttpErrorResponse } from '@angular/common/http';
import { filter, catchError, Observable, tap, OperatorFunction } from 'rxjs';

export const isTruthy = <T>() => {
  return filter<T>((value) => !!value);
};

export const isFalsy = <T>() => {
  return filter<T>((value) => !value);
};

/**
 * Tap into all responses of an observable, handling next, error, and complete
 * The observer won't complete upon an error.
 * This operator makes sure that an error callback is provided.
 * @param next Next callback
 * @param error Error callback
 * @param complete Optional complete callback
 */

export function tapAllResponses<T, E = HttpErrorResponse>(
  next: (value: T) => void,
  error: (err: E) => void,
  complete?: () => void,
): OperatorFunction<T, T> {
  return (source$: Observable<T>): Observable<T> =>
    source$.pipe(
      tap({ next, complete }),
      catchError((err, caught$) => {
        error(err);
        return caught$;
      }),
    );
}
